import React,{useEffect, useState} from 'react';
import Portal from '../Portal';
import cross from './close.png';
import left from "./left.png";
import right from "./right.png";
import Rright from "./Rright.png";
import Rleft from "./Rleft.png";
import download from "./download.png"
import Saver from 'file-saver';
import PDF from '../fPhoto/pdf.png';
import EXCEL from '../fPhoto/excel.png';
import DOC from "../fPhoto/doc.png"
import plus from "./plus.png"
import minus from "./minus.png"

const OpenImage = ({image,close,list=[]}) => {
    
    if(!image) {
        return <></>
    }
    const [IMG,setIMG] = useState();
	const [rotation,setRotation] = useState(0);
    const [showZoom,setShowZoom] = useState(image && (image.endsWith('.png')||image.endsWith('.jpg')||image.endsWith('.jpeg')));
    const [zoom,setZoom] = useState(100);
    const [index,setIndex] = useState(undefined);
    let initialIndex = -1;

    const imageLinkHandler = (image) => {
        setZoom(100)
        if(image.endsWith('.pdf')){
            setIMG(PDF);
            setShowZoom(false)
        }else if(image.endsWith('.csv') || image.endsWith('.xlsx')){
            setIMG(EXCEL);
            setShowZoom(false)
        }else if(image.endsWith('.png') || image.endsWith('.jpg')|| image.endsWith('.jpeg') || image.endsWith("map")){
            setShowZoom(true)
            setIMG(image);
        }else {
            setIMG(DOC);
            setShowZoom(false)
        }
    }
    useEffect(()=>{
        imageLinkHandler(image)
        if(list && initialIndex === -1){
            let ind = list.findIndex(el=> el.path === image);
            setIndex(ind);
        }
    },[])
    const next = ()=>{
        let ind = index;
        if((ind<(list.length-1))){
            imageLinkHandler(list[ind+1].path);
			setIndex(ind+1);
		}
    }
    const prev = ()=>{
        let ind = index;
        if((ind>0)){
            imageLinkHandler(list[ind-1].path);
			setIndex(ind-1);
		}
    }
    //Image download function
    const downloadImgaeHandler = ()=>{
        Saver.saveAs(list[index].path, 'attachment');
    }
    return(
       <Portal>
         <div>
            <div style={{
                maxWidth:'40%',
                height:'100%',
                boxShadow: '5px 2px 10px #f3f2f2',
                background:'#fff',
                zIndex:111111,
                border:'1px solid var(--border-color)',
                borderRadius:8,
                position:'fixed',
                left:4,
                top:0,
            }}>
                <div style={{height:30,display:'flex',borderBottom:'1px solid var(--border-color)',background:'var(--sidebar-color)',alignItems:'center',justifyContent:'space-between'}}>
                    <div onClick={(e)=>{
                        e.stopPropagation();

                        if(list[index] && list[index].path.includes('pdf')) {
                            window.open(list[index].path,"_blank")
                        } else {
                            window.open(IMG,"_blank")
                        }
                    }} style={{fontSize:9,paddingLeft:5,cursor:'pointer'}}>
                        {IMG}
                    </div>
                    <div style={{width:50,fontSize:14,display:'flex',cursor:'pointer',justifyContent:'center',color:'var(--primary-color)'}}>
                        <img onClick={(e)=>{
                            e.stopPropagation();
                            close();
                        }} src={cross} alt="" style={{width:14,height:14}} />
                    </div>
                </div>
                <div style={{height:'100%', overflow:'auto'}}>
                    <div style={{width:`${zoom}%`,height:`${zoom}%`}}>
                        <img src={IMG} alt="" style={{width:'100%',height:'100%',objectFit:'contain',borderRadius:8,transform: `rotate(${rotation}deg)`}} />
                    </div>
                </div>

                {!!list.length &&
					<div style={{display:'flex',alignItems:'center', justifyContent:'space-between',border:'1ps solid #eaeaea', borderRadius:'0.5rem',cursor: 'pointer', fontSize: '18px', margin: 'auto', marginBottom: '15px', position: 'absolute', bottom: '10px', left: '24%', background: '#f2f2f2' }}>
                        <img alt='prev' src={left} height={43} width={43} style={{borderRadius:'0.5rem',padding:'0.5rem', textAlign: 'center' }} onClick={() => { prev();setRotation(0)}}/>
                        <img alt='left-rotate' src={Rleft} height={36} width={36} style={{borderRadius:'0.5rem',padding:'0.5rem', textAlign: 'center' }} onClick={() => { setRotation(prev => prev - 90)}}/>
                        <img alt='download' src={download} height={36} width={36} style={{borderRadius:'0.5rem',padding:'0.5rem', textAlign: 'center' }} onClick={downloadImgaeHandler}/>
                        {(showZoom)?<img alt='minus' src={minus} height={36} width={36} style={{borderRadius:'0.5rem',padding:'0.5rem', textAlign: 'center' }} onClick={()=>{setZoom(prev=>prev-10)}}/>:null}
                        {(showZoom)?<img alt='plus' src={plus} height={36} width={36} style={{borderRadius:'0.5rem',padding:'0.5rem', textAlign: 'center' }} onClick={()=>{setZoom(prev=>prev+10)}}/>:null}
                        <img alt='right-rotate' src={Rright} height={36} width={36} style={{borderRadius:'0.5rem',padding:'0.5rem', textAlign: 'center' }} onClick={() => { setRotation(prev => prev + 90)}}/>
                        <img alt='next' src={right} height={43} width={43} style={{borderRadius:'0.5rem',padding:'0.5rem', textAlign: 'center' }} onClick={() => { next();setRotation(0)}}/>
					</div>
				}
            </div>
         </div>
       </Portal>
        
        
    )
}

export {OpenImage}